import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from "./routes";
import store from "~/store";

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeResolve((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters['auth/isLoggedIn']) {
            next()
            return
        }
        next('login')
    } else {
        next()
    }
})

export default router
